import { useEffect, useState } from "react";
import { validateDiscountsValuesJson } from "../utils/shopGridDiscounts";

let discountsValuesCache = null;
let discountsValuesCachePromise = null;

const loadDiscountsValues = async () => {
  if (discountsValuesCache) return discountsValuesCache;
  if (discountsValuesCachePromise) return discountsValuesCachePromise;

  discountsValuesCachePromise = fetch("/discountsValues", { cache: "no-store" })
    .then(async (res) => {
      if (!res.ok) {
        throw new Error("Configurazione sconti non disponibile");
      }
      const text = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(text);
      } catch {
        throw new Error("Configurazione sconti non disponibile");
      }
      const validated = validateDiscountsValuesJson(parsed);
      discountsValuesCache = validated;
      return discountsValuesCache;
    })
    .finally(() => {
      discountsValuesCachePromise = null;
    });

  return discountsValuesCachePromise;
};

export const useDiscountsValues = ({ enabled }) => {
  const [discountsValues, setDiscountsValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    setLoading(true);
    setError("");

    loadDiscountsValues()
      .then((data) => {
        if (cancelled) return;
        setDiscountsValues(data);
      })
      .catch((e) => {
        if (cancelled) return;
        setDiscountsValues(null);
        setError(e?.message || "Configurazione sconti non disponibile");
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { discountsValues, loading, error };
};

